import { render, staticRenderFns } from "./RsaPazientePrescrizioniPage.vue?vue&type=template&id=38d08390"
import script from "./RsaPazientePrescrizioniPage.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioniPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports